import { IsoLanguagesRegions } from '../enums/locale.js';

const DEFAULT_ISO_LANGUAGE_REGION = IsoLanguagesRegions.EN;

export { DEFAULT_ISO_LANGUAGE_REGION };
//# sourceMappingURL=locale.js.map
